/**
 * Top menu and side menu scripts
 */

(function($) {
	//# Init variables

	// Selectors & CSS classes
	let hasSubmenuSelector     = '.menu-item-has-children';
	let sideMenuSelector       = '.mobile-slide-menu';
	let activeClass            = 'is-activated';

	// jQuery objects
	let $topMenu               = $('#menu-main');
	let $sideMenuToggleButton  = $('.mobile-menu-hamburger > .main-hamburger');
	let $sideMenu              = $('.mobile-slide-menu');
	let $sideMenuClose         = $sideMenu.find('.close').first();
	let $sideMenuBack          = $sideMenu.find(`${sideMenuSelector}__back`).first();

	// Misc. settings
	let transitionTime         = 500;
	let mobileTabActive        = false;


	$(document).ready(function() {
		mobileSlideBodyAppend();

		//# Top Menu (optimized for pointer/desktop)

		$topMenu.find(hasSubmenuSelector).each(function() {
			let $dropdown = $(this);
			let $dropdownLink = $dropdown.find('> a');
			let $dropdownMenu = $dropdown.find('> .menu');

			let $dropdownItems = $dropdownMenu.children();
			let itemDelay = 0;

			$dropdownItems.each(function() {
				let $thisItem = $(this);
				$thisItem.css('transition-delay', `${itemDelay}ms`);
				itemDelay += 100;

				let $itemLink = $thisItem.find('a');
				$itemLink.addClass('is-child');

				$itemLink.on({
					focus: function() {
						$dropdownMenu.addClass(activeClass);
					},
					blur: function(event) {
						if ( !$(event.relatedTarget).hasClass('is-child') ) {
							$dropdownMenu.removeClass(activeClass);
						}
					},
				});
			});

			$topMenu.find('a[href="#"]').on('click', function (e) {
				e.preventDefault();
			});
			$sideMenu.find('a[href="#"]').on('click', function (e) {
				e.preventDefault();
			});

			// Should only activate when interacting with the item
			$dropdownLink.on({
				focus: function() {
					$(this).closest(hasSubmenuSelector).addClass(activeClass).find('.menu').first().addClass(activeClass);
				},
				blur: function(event) {
					if ( !$(event.relatedTarget).hasClass('is-child') ) {
						$(this).closest(hasSubmenuSelector).removeClass(activeClass).find('.menu').first().removeClass(activeClass);
					}
				},
			});
			$dropdown.hoverIntent({
				over: function () {
					$(this).closest(hasSubmenuSelector).addClass(activeClass).find('.menu').first().addClass(activeClass);
				},
				out: function (event) {
					$(this).closest(hasSubmenuSelector).removeClass(activeClass).find('.menu').first().removeClass(activeClass);
				},
				timeout: 500
			});

		});


		//# Side Menu (optimized for touch/mobile)

		//# – Functions

		function mobileSlideBodyAppend() {
			if ( $sideMenu.length ) {
				$sideMenu.appendTo('body');
			}
		}

		function focusFirstMenuItem() {
			if ( !mobileTabActive ) {
				$sideMenuClose.focus(); // first menu item focused
				mobileTabActive = true;
			}
		}

		function windowHandleKeydown(event) {
			if ( $sideMenu.hasClass(activeClass) ) {
				switch (event.keyCode) {
					// Enter
					case 27:
						mobileMenuToggle();
						break;
					// Tab
					case 9:
						focusFirstMenuItem();
						break;
				}
			}
		}

		function mobileMenuToggle() {
			if ( $sideMenu.hasClass(activeClass) ) {
				$sideMenu.removeClass(activeClass);
				setTimeout(function() {
					$sideMenu.css('display', 'none');
				}, transitionTime + 100); // little extra for good measure
				mobileTabActive = false;
			} else {
				$sideMenu.css('display', 'block');
				setTimeout(function() {
					$sideMenu.addClass(activeClass);
				}, 100);
			}
		}

		function mobileSlideClick(event) {
			if ( $sideMenu.hasClass(activeClass) ) {
				let $target = $(event.target);
				if ( $target.hasClass('mobile-slide-menu') || $target.is('a') ) {
					mobileMenuToggle();
				}
			}
		}

		let sideMenuUtil = {
			getParentMenus($thisMenu) {
				return $thisMenu.parentsUntil(sideMenuSelector, hasSubmenuSelector);
			},
			openSubmenu($thisMenu) {
				let $thisParentMenus = this.getParentMenus($thisMenu);
				let thisMenuDepth = $thisParentMenus.length;

				$thisMenu.addClass(activeClass);
				$thisMenu.find('.menu').first().addClass(activeClass).slideDown();

				if (thisMenuDepth > 0) {
					$sideMenuBack.fadeIn();
					$thisMenu.siblings().fadeOut();
					$thisParentMenus.siblings().fadeOut();
				}
			},
			closeSubmenu($thisMenu) {
				let $thisParentMenus = this.getParentMenus($thisMenu);
				let thisMenuDepth = $thisParentMenus.length;

				// Close any children
				let $thisMenuChild = $thisMenu.find('.menu').first();

				let self = this;
				$thisMenuChild.find(`${hasSubmenuSelector}.${activeClass}`).each(function(){
					self.closeSubmenu( $(this) );
				});

				// Close self
				$thisMenu.removeClass(activeClass);
				$thisMenuChild.removeClass(activeClass).slideUp();

				if (thisMenuDepth > 0) {
					$sideMenuBack.fadeOut();
					$thisMenu.siblings().fadeIn();
					$thisParentMenus.siblings().fadeIn();
				}
			},
			closeDeepestSubmenu() {
				this.closeSubmenu( $sideMenu.find(`${hasSubmenuSelector}.${activeClass}`).last() );
			},
		};


		//# – Attach events

		$sideMenu.find(hasSubmenuSelector).each(function() {
			let $dropdown = $(this);
			let $dropdownLink = $dropdown.find('> a');
			let $dropdownMenu = $dropdown.find('> .menu');

			$dropdownMenu.hide();

			// Should only activate when interacting with the item
			$dropdownLink.on({
				click: function (e) {
					let $thisMenu = $(this).closest(hasSubmenuSelector);
					let $thisParentMenus = $thisMenu.parentsUntil(sideMenuSelector, hasSubmenuSelector);
					let thisMenuDepth = $thisParentMenus.length;

					if ( !$thisMenu.hasClass(activeClass) ) {
						sideMenuUtil.openSubmenu($thisMenu);
					} else {
						sideMenuUtil.closeSubmenu($thisMenu);
					}
				},
			});
		});

		$sideMenuToggleButton.on({
			click: function(e) {
				e.preventDefault();
				mobileMenuToggle();
			},
			keydown: function(e) {
				if ( e.key === 'Enter') {
					e.preventDefault();
					mobileMenuToggle();
					$(this).blur();
				}
			}
		});

		$sideMenuClose.on({
			click: function(e) {
				e.preventDefault();
				mobileMenuToggle();
			},
			keydown: function(e) {
				if ( e.key === 'Enter') {
					e.preventDefault();
					mobileMenuToggle();
				}
			}
		});

		$sideMenuBack.on('click', function (e) {
			e.preventDefault();
			sideMenuUtil.closeDeepestSubmenu();
		});

		$(window).on('keydown', function(e) {
			windowHandleKeydown(e);
		});

		$(window).on('click', function(e) {
			mobileSlideClick(e);
		});

	}); // document ready

})(jQuery);
